import React from 'react';
import { Minus, Plus } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

/** Generic labeled +/- stepper — used by GroupingStep (group/advance counts) and the legs (matches-per-pairing) control. */
const Stepper = ({ label, value, onChange, min, max, hint }) => {
  const { theme } = useTheme();
  return (
    <div className="flex items-center justify-between gap-4">
      <div>
        {label && <div className={`text-sm font-medium ${theme.text}`}>{label}</div>}
        {hint && <div className={label ? `text-xs ${theme.textMuted}` : `text-sm font-medium ${theme.text}`}>{hint}</div>}
      </div>
      <div className={`flex items-center gap-1 rounded-full border ${theme.border} p-1`}>
        <button
          type="button"
          onClick={() => onChange(Math.max(min, value - 1))}
          disabled={value <= min}
          className={`flex h-7 w-7 items-center justify-center rounded-full transition-colors ${theme.buttonGhost} disabled:opacity-30`}
        >
          <Minus size={14} />
        </button>
        <span className={`w-8 text-center text-sm font-semibold tabular-nums ${theme.text}`}>{value}</span>
        <button
          type="button"
          onClick={() => onChange(Math.min(max, value + 1))}
          disabled={value >= max}
          className={`flex h-7 w-7 items-center justify-center rounded-full transition-colors ${theme.buttonGhost} disabled:opacity-30`}
        >
          <Plus size={14} />
        </button>
      </div>
    </div>
  );
};

export default Stepper;
